<template>
  <div v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading">
    <div class="course-chapter" v-for="(item,index) in courseList" :key="index">
      <dl class="course-catalogue">
        <dt class="course-catalogue-title">
          第{{ index + 1 || '' }}章 {{ item.name || '' }}
        </dt>
        <dd class="course-catalogue-Subsection pointer flex flex_space-between" @click="handleRouter(v, item)"
            v-for="(v,i) in item.list"
            :key="i">
          <div>
            <i class="iconfont icon-sp"></i>
            <span style="margin-left: 10px">
              {{ `${index + 1}-${i + 1} ${v.studySection.name}` }}
              (总时长：{{ v.totalTime | initTime }})
            </span>
          </div>

          <div>
            <span v-if="v.totalTime === v.studyTime && v.totalTime"><b style="color: #67c23a">已完成</b>    </span>
            <span v-if="v.totalTime !== v.studyTime && v.studyTime"><b  style="color: #409eff">正在学习中</b> ({{ v.studyTime| initTime }})   </span>
            <span v-if="!v.studyTime"> <b style="color: #f56c6c">未开始</b></span>
          </div>

        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: "Chapter",
  props: {
    courseId: [String, Number]
  },
  data() {
    return {
      courseList: [],
      loading: true
    }
  },
  methods: {
    handleRouter(v, item) {
      // 没有视频资源不做跳转
      if (!v.studySection.vedioURL) return this.$alert('当前小节，暂无视频资源，请查看其他小节，或联系管理员进行添加', '小节提示', {
        confirmButtonText: '确定',
      });

      if (v.isComplete === '1') return this.$alert('当前小节，播放完成，请勿重新观看', '小节提示', {
        confirmButtonText: '确定',
      });

      this.$router.push({
        path: '/video',
        query: {
          courseId: this.$route.query.courseId,
        }
      })
      sessionStorage.setItem('sectionId', v.id)
    }
  },
  watch: {
    courseId(val) {
      this.$get(this.$API.MY_SECTION_LIST, {
        studyCourseId: val
      }).then(res => {
        this.courseList = res.data

        this.loading = false
      })
    }
  },
  filters: {
    initTime(val) {
      let time;
      // 转换为式分秒
      let h = parseInt(val / 60 / 60 % 24)
      h = h < 10 ? '0' + h : h
      let m = parseInt(val / 60 % 60)
      m = m < 10 ? '0' + m : m
      let s = parseInt(val % 60)
      s = s < 10 ? '0' + s : s
      if (h === '00') {
        time = m + ':' + s
      } else {
        time = h + ':' + m + ':' + s
      }
      // 作为返回值返回
      if (val) {
        return time
      } else {
        return '00:00:00'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.course-chapter {
  margin-bottom: $spacing-row-sm;
  padding: 24px 32px 32px;
  background: #fff;
  box-shadow: 0 8px 16px 0 rgb(7 17 27 / 10%);
  border-radius: 12px;

  .course-catalogue {
    &-title {
      color: $font-text-color;
      font-size: $font-size-md;
      font-weight: 700;
      line-height: 24px;
    }

    &-Subsection {
      margin-top: $spacing-row-sm;
      padding: 0 $spacing-row-base;
      color: $font-text-color;
      font-size: $font-size-base;
      line-height: 40px;

      &:hover {
        background: #409eff;
        color: $font-text-color-inverse;
      }
    }

  }
}
</style>
